import React from "react";

interface DetailFieldProps {
  label: string;
  children: React.ReactNode;
}

export const DetailField: React.FC<DetailFieldProps> = ({
  label,
  children,
}) => {
  return (
    <div>
      <label className="text-sm font-medium text-muted-foreground">
        {label}
      </label>
      <div className="mt-1">{children}</div>
    </div>
  );
};
